import { API_METHOD } from "types/common";

type EVLOADResponse = {
  EV: {
    countDetails: {
      enrolledCount: number;
      chargingCount: number;
      controllableCount: number;
    };
    loadDetails: {
      enrolledLoad: number;
      chargingLoad: number;
      controllableLoad: number;
    };
    lastSyncDTO: {
      refreshLeft: number;
      lastSync: string; // You might want to use a Date type if it's always in a specific format
    };
  };
};

/*==============================================================================
                                 A P I S
==============================================================================*/

export class EVLoadManagementAPIEndpoints {
  static GET_LOAD = (pilotId: string) =>
    `/v2.0/dre/pilotId/${pilotId}/load-element`;
  static REFRESH_LOAD = (pilotId: number) =>
    `/v2.0/dre/pilotId/${pilotId}/refresh`;
  static REFRESH_LOAD_STATUS = (pilotId: number) =>
  `/v2.0/dre/pilotId/${pilotId}/status`;
}

export namespace GetEVLoadAPI {
  export const method: API_METHOD = "GET";

  export const apiEndpoint = EVLoadManagementAPIEndpoints.GET_LOAD;

  export type retval = EVLOADResponse;
}

export namespace RefreshEVLoadAPI {
  export const method: API_METHOD = "POST";

  export const apiEndpoint = EVLoadManagementAPIEndpoints.REFRESH_LOAD;

  export type retval = any;
}

export namespace EVLoadRefreshStatusAPI {
  export const method: API_METHOD = "GET";

  export const apiEndpoint = EVLoadManagementAPIEndpoints.REFRESH_LOAD_STATUS;

  export type params = {
    requestId  : string 
  }

  export type retval = any;
}